import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import proces from "../images/proces.png";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";

const sections = [
  {
    title: "§ 1. Cel i zakres Procedury",
    paragraphs: [
      "Niniejszy Regulamin określa zasady prowadzenia procesu weryfikacji oraz kontroli Opiekunek korzystających z serwisu twojaopiekunka.pl.",
      "Celem procesu jest zwiększenie bezpieczeństwa osób poszukujących usług opiekuńczych oraz zapewnienie Użytkownikom możliwie przejrzystej informacji o doświadczeniu, kwalifikacjach i określonych umiejętnościach Opiekunki.",
      "Weryfikacja jest procesem wieloetapowym. Operator może wdrażać wszystkie albo wybrane etapy, zależnie od rodzaju profilu, zakresu oferowanych usług i aktualnie obowiązujących zasad programu weryfikacji.",
      "Weryfikacja nie stanowi certyfikacji zawodowej, licencji, gwarancji jakości usług ani przejęcia przez Operatora odpowiedzialności za sposób wykonywania usług przez Opiekunkę.",
    ],
  },
  {
    title: "§ 2. Zasady podstawowe",
    bullets: [
      "rzetelność – informacje przedstawione przez Opiekunkę powinny być prawdziwe i aktualne;",
      "przejrzystość – Opiekunka jest informowana o zakresie przeprowadzanej weryfikacji;",
      "proporcjonalność – Operator gromadzi i sprawdza tylko informacje potrzebne do realizacji danego etapu;",
      "bezpieczeństwo – proces ma służyć ograniczeniu ryzyka dla podopiecznych i Użytkowników;",
      "niedyskryminacja – kryteria weryfikacji stosuje się według obiektywnych zasad;",
      "ochrona prywatności – czynności kontrolne nie mogą wykraczać poza zakres dopuszczalny prawem i odpowiednią podstawą uprawniającą do ich wykonania.",
    ],
  },
  {
    title: "§ 3. Etapy weryfikacji",
    paragraphs: [
      "Standardowy proces może obejmować następujące etapy: rejestrację, potwierdzenie danych, weryfikację dokumentów, ocenę doświadczenia, weryfikację referencji, ocenę określonych umiejętności oraz okresowe ponowne sprawdzenie wybranych informacji.",
      "Operator może wprowadzać dodatkowe poziomy weryfikacji. Każdy poziom powinien mieć jasno opisane kryteria oraz znaczenie statusu prezentowanego w profilu.",
    ],
    numbered: [
      "Utworzenie profilu i przekazanie wymaganych danych.",
      "Potwierdzenie tożsamości.",
      "Weryfikacja dokumentów dotyczących kwalifikacji i doświadczenia.",
      "Weryfikacja referencji, jeżeli Opiekunka je podała.",
      "Ocena wybranych umiejętności praktycznych lub teoretycznych.",
      "Nadanie odpowiedniego statusu weryfikacyjnego.",
      "Okresowe odnowienie lub aktualizacja wybranych elementów weryfikacji.",
      "Kontrola zgodności deklarowanych informacji z rzeczywistym sposobem wykonywania uzgodnionych obowiązków, jeżeli jest przewidziana dla danego programu.",
    ],
  },
  {
    title: "§ 4. Weryfikacja tożsamości",
    paragraphs: [
      "Operator może wymagać potwierdzenia tożsamości Opiekunki przed przyznaniem określonego statusu weryfikacyjnego.",
      "Sposób potwierdzenia tożsamości może obejmować rozwiązanie elektroniczne, dokument tożsamości lub inną metodę adekwatną do poziomu bezpieczeństwa wymaganej usługi.",
      "Dane dokumentu tożsamości nie powinny być publicznie prezentowane w profilu. Zakres przechowywanych danych i czas ich przechowywania określa Polityka Prywatności oraz dokumentacja procesu ochrony danych.",
    ],
  },
  {
    title: "§ 5. Weryfikacja kwalifikacji i doświadczenia",
    paragraphs: [
      "Opiekunka może zostać poproszona o przedstawienie dokumentów potwierdzających deklarowane kwalifikacje, kursy, szkolenia, doświadczenie lub inne kompetencje.",
      "Operator może porównać informacje podane w profilu z przedstawionymi dokumentami.",
      "W przypadku stwierdzenia rozbieżności Operator może poprosić Opiekunkę o wyjaśnienie lub dodatkowe dokumenty.",
      "Świadome podanie nieprawdziwych informacji może skutkować odmową przyznania statusu, jego cofnięciem, ograniczeniem widoczności profilu lub zawieszeniem Konta.",
    ],
  },
  {
    title: "§ 6. Referencje",
    paragraphs: [
      "Opiekunka może wskazać osoby, które mogą potwierdzić jej doświadczenie.",
      "Kontakt z osobą udzielającą referencji może nastąpić wyłącznie w zakresie zgodnym z prawem i zasadami ochrony danych.",
      "Operator może odnotować fakt pozytywnego lub negatywnego wyniku weryfikacji referencji, bez publikowania niepotrzebnych danych osobowych osoby udzielającej referencji.",
      "Operator nie gwarantuje prawdziwości informacji uzyskanych od osób trzecich, chyba że obowiązek takiej gwarancji wynika z prawa.",
    ],
  },
  {
    title:
      "§ 7. Ocena umiejętności przez osobę posiadającą odpowiednie kwalifikacje",
    paragraphs: [
      "W ramach programu weryfikacji Operator może organizować ocenę praktycznych lub teoretycznych umiejętności Opiekunki.",
      "Ocena może być przeprowadzana przez wykwalifikowaną pielęgniarkę albo inną osobę posiadającą kompetencje odpowiednie do ocenianego zakresu.",
      "Zakres oceny może obejmować w szczególności bezpieczeństwo podopiecznego, podstawowe czynności opiekuńcze, higienę, pomoc osobie niesamodzielnej, reagowanie w sytuacjach nagłych oraz inne umiejętności określone w aktualnym programie.",
      "Osoba oceniająca może sporządzić raport zawierający wynik oraz uzasadnienie wyniku.",
      "Operator może przedstawić w profilu jedynie informacje potrzebne do zakomunikowania statusu weryfikacji. Szczegółowy raport oceny nie powinien być publicznie dostępny, chyba że istnieje odpowiednia podstawa do jego udostępnienia.",
    ],
  },
  {
    title: "§ 8. Wynik weryfikacji i statusy",
    paragraphs: [
      "Operator może stosować oznaczenia statusów, np. „Tożsamość potwierdzona”, „Dokumenty zweryfikowane”, „Umiejętności sprawdzone” lub „Zweryfikowana Opiekunka”.",
      "Każdy status powinien odpowiadać konkretnemu zakresowi czynności, które faktycznie zostały przeprowadzone.",
      "Status „Zweryfikowana Opiekunka” nie oznacza, że Operator gwarantuje bezpieczeństwo, uczciwość, kompetencje lub przyszły sposób wykonywania usług przez Opiekunkę.",
      "Status może mieć termin ważności albo wymagać okresowej aktualizacji.",
      "Operator może cofnąć lub zawiesić status, jeżeli przestały być spełnione warunki jego przyznania.",
    ],
  },
  {
    title: "§ 9. Informacje dotyczące niekaralności",
    paragraphs: [
      "Jeżeli program bezpieczeństwa przewiduje sprawdzenie informacji dotyczących skazań lub czynów zabronionych, czynność ta może być wykonana wyłącznie w zakresie dopuszczalnym przez obowiązujące przepisy.",
      "Dane dotyczące wyroków skazujących i czynów zabronionych podlegają szczególnym zasadom wynikającym z art. 10 RODO. Operator nie może traktować samej zgody Użytkownika jako automatycznej podstawy do dowolnego przetwarzania takich danych.",
      "Jeżeli dla określonego rodzaju pracy istnieje szczególny obowiązek prawny dotyczący weryfikacji karalności, Operator może przeprowadzić weryfikację w zakresie wynikającym z właściwych przepisów.",
      "Informacja o wyniku weryfikacji, jeżeli może być zgodnie z prawem prezentowana, powinna być ograniczona do minimum niezbędnego dla celu bezpieczeństwa, np. poprzez status weryfikacyjny zamiast publikacji dokumentu.",
      "Szczegółowe zasady tej części procesu określa dokumentacja ochrony danych i Polityka Prywatności.",
    ],
  },
  {
    title: "§ 10. Odmowa lub negatywny wynik weryfikacji",
    paragraphs: [
      "Operator może odmówić przyznania określonego statusu, jeżeli Opiekunka nie przedstawi wymaganych informacji, nie przejdzie danego etapu lub wystąpią uzasadnione rozbieżności wymagające wyjaśnienia.",
      "Negatywny wynik jednego etapu nie musi automatycznie oznaczać usunięcia Konta, chyba że charakter stwierdzonej nieprawidłowości uzasadnia takie działanie.",
      "Przed podjęciem decyzji o trwałym ograniczeniu Konta Operator może, w odpowiednich przypadkach, umożliwić Opiekunce przedstawienie wyjaśnień lub dodatkowych dokumentów.",
      "Jeżeli decyzja dotyczy moderacji treści lub ograniczenia usługi w zakresie objętym DSA, Użytkownikowi przysługuje odpowiedni wewnętrzny środek odwoławczy.",
    ],
  },
  {
    title: "§ 11. Kontrole jakości",
    paragraphs: [
      "Operator może prowadzić kontrole jakości w celu sprawdzenia określonych elementów wykonywania usług oraz zgodności informacji przedstawionych w profilu.",
      "Kontrola może obejmować rozmowę z Opiekunką, analizę dokumentacji, kontakt z osobą korzystającą z usług, obserwację uzgodnionych czynności lub inne działania mieszczące się w prawnie dopuszczalnym zakresie.",
      "Kontrola powinna być przeprowadzana według określonych kryteriów, a jej wynik powinien być udokumentowany w sposób umożliwiający późniejsze odtworzenie podstaw decyzji.",
    ],
  },
  {
    title: "§ 12. Kontrole niezapowiedziane",
    paragraphs: [
      "W ramach programu jakości Operator może przewidywać kontrole niezapowiedziane.",
      "Kontrola niezapowiedziana nie oznacza prawa Operatora ani kontrolera do swobodnego wejścia do prywatnego mieszkania, domu lub innego miejsca bez odpowiedniej podstawy prawnej, zgody albo innej skutecznej podstawy uprawniającej do przeprowadzenia kontroli.",
      "Jeżeli kontrola ma odbywać się w miejscu prywatnym, warunki jej przeprowadzenia powinny być wcześniej uregulowane w odpowiedniej umowie, regulaminie lub zgodzie, z uwzględnieniem praw wszystkich osób znajdujących się w tym miejscu.",
      "Kontroler może zostać zobowiązany do okazania identyfikatora oraz informacji o celu kontroli.",
      "Jeżeli warunki przeprowadzenia kontroli nie są spełnione, kontrola może zostać przerwana albo nieprzeprowadzona.",
    ],
  },
  {
    title: "§ 13. Kontrolerzy",
    paragraphs: [
      "Kontrole mogą wykonywać pracownicy Operatora albo osoby współpracujące z Operatorem, posiadające kompetencje odpowiednie do zakresu kontroli.",
      "Operator może wymagać od kontrolera zachowania poufności oraz przestrzegania zasad ochrony danych osobowych.",
      "Kontroler powinien działać w sposób bezstronny, kulturalny i proporcjonalny do celu kontroli.",
      "Kontroler nie może podejmować czynności wykraczających poza zakres udzielonego mu upoważnienia.",
    ],
  },
  {
    title: "§ 14. Raport z kontroli",
    paragraphs: [
      "Z kontroli może zostać sporządzony raport.",
      "Raport może zawierać datę, zakres kontroli, ustalenia, stwierdzone nieprawidłowości oraz zalecenia.",
      "Jeżeli raport zawiera dane osobowe podopiecznego lub innych osób, Operator ogranicza zakres danych do niezbędnego minimum.",
      "Opiekunka może otrzymać informację o wyniku kontroli oraz o działaniach, które powinna podjąć w związku z ustaleniami, z zastrzeżeniem ograniczeń wynikających z prawa i ochrony danych innych osób.",
    ],
  },
  {
    title: "§ 15. Nieprawidłowości i działania naprawcze",
    numbered: [
      "zalecenie uzupełnienia brakujących dokumentów;",
      "wezwanie do aktualizacji profilu;",
      "ponowna weryfikacja określonego elementu;",
      "czasowe zawieszenie określonego statusu;",
      "ograniczenie widoczności profilu;",
      "zawieszenie Konta;",
      "usunięcie Konta – w przypadkach przewidzianych Regulaminem i prawem.",
    ],
    paragraphs: [
      "Rodzaj zastosowanego działania powinien być proporcjonalny do charakteru i wagi stwierdzonej nieprawidłowości.",
    ],
  },
  {
    title: "§ 16. Natychmiastowe zagrożenie bezpieczeństwa",
    paragraphs: [
      "Jeżeli Operator otrzyma wiarygodną informację o sytuacji mogącej stwarzać bezpośrednie zagrożenie życia lub zdrowia podopiecznego, może niezwłocznie ograniczyć dostęp do Serwisu lub statusy Opiekunki do czasu wyjaśnienia sprawy.",
      "Jeżeli sytuacja wymaga interwencji służb publicznych, osoba posiadająca wiedzę o zagrożeniu powinna skontaktować się z właściwymi służbami.",
      "Działania Operatora nie zastępują interwencji medycznej, policyjnej ani innych właściwych organów.",
    ],
  },
  {
    title: "§ 17. Odwołanie od wyniku weryfikacji lub kontroli",
    paragraphs: [
      "Opiekunka może złożyć odwołanie od decyzji dotyczącej jej statusu, wyniku kontroli albo ograniczenia funkcjonalności Konta.",
      "Odwołanie można złożyć za pomocą formularza [UZUPEŁNIJ: adres formularza] albo na adres kontakt@allworks.pl.",
      "Odwołanie powinno wskazywać decyzję, której dotyczy, oraz zawierać informacje lub dokumenty, które Opiekunka uważa za istotne.",
      "Operator może ponownie przeanalizować sprawę, poprosić o dodatkowe informacje lub przeprowadzić ponowną weryfikację.",
      "Jeżeli decyzja podlega procedurze odwoławczej wynikającej z DSA, procedura wewnętrzna powinna być dostępna przez okres wymagany prawem.",
    ],
  },
  {
    title: "§ 18. Ochrona danych osobowych",
    paragraphs: [
      "Operator przetwarza dane osobowe związane z weryfikacją i kontrolą zgodnie z obowiązującymi przepisami o ochronie danych osobowych.",
      "Zakres danych, podstawy prawne, cele, okresy przechowywania, odbiorcy danych oraz prawa osób, których dane dotyczą, są opisane w Polityce Prywatności.",
      "Dokumenty przekazane do weryfikacji nie powinny być publikowane w profilu Opiekunki, chyba że istnieje odpowiednia podstawa prawna i jest to niezbędne do realizacji określonego celu.",
      "Dane dotyczące zdrowia, karalności lub inne dane szczególnie chronione mogą być przetwarzane wyłącznie w przypadkach i na zasadach dopuszczonych przez prawo.",
    ],
  },
  {
    title: "§ 19. Poufność",
    paragraphs: [
      "Operator, kontrolerzy oraz osoby uczestniczące w procesie weryfikacji są zobowiązani do zachowania poufności informacji uzyskanych w związku z wykonywaniem swoich obowiązków w zakresie wynikającym z prawa i zawartych umów.",
      "Informacje o podopiecznych, ich stanie, miejscu zamieszkania, sytuacji rodzinnej oraz inne informacje prywatne powinny być traktowane jako informacje poufne.",
    ],
  },
  {
    title: "§ 20. Zmiany Procedury",
    paragraphs: [
      "Operator może zmienić niniejszy Regulamin w szczególności w związku ze zmianą prawa, zmianą modelu działania Serwisu, wprowadzeniem nowych poziomów weryfikacji albo zmianą kryteriów bezpieczeństwa.",
      "Zmiany nie mogą działać z mocą wsteczną na niekorzyść Użytkownika, chyba że wynika to z obowiązującego prawa.",
      "O zmianach Użytkownicy zostaną poinformowani w sposób umożliwiający zapoznanie się z nową treścią.",
    ],
  },
  {
    title: "§ 21. Postanowienia końcowe",
    paragraphs: [
      "Niniejszy Regulamin stanowi uzupełnienie Regulaminu Serwisu twojaopiekunka.pl.",
      "W przypadku sprzeczności pomiędzy niniejszym dokumentem a bezwzględnie obowiązującymi przepisami prawa pierwszeństwo mają przepisy prawa.",
      "W sprawach nieuregulowanych zastosowanie mają postanowienia Regulaminu Serwisu oraz obowiązujące przepisy prawa.",
      "Wersja dokumentu: 1.0.",
      "Data wejścia w życie: 2026-09-01.",
    ],
  },
];

function Section({ section }) {
  return (
    <section className="weryfikacja__section">
      <h2>{section.title}</h2>

      {section.paragraphs?.map((text, index) => (
        <p key={`p-${index}`}>{text}</p>
      ))}

      {section.numbered && (
        <ol>
          {section.numbered.map((item, index) => (
            <li key={`n-${index}`}>{item}</li>
          ))}
        </ol>
      )}

      {section.bullets && (
        <ul>
          {section.bullets.map((item, index) => (
            <li key={`b-${index}`}>{item}</li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default function RegulaminWeryfikacjiOpiekunek() {
  const { userData } = useContext(UserDataContext);
  return (
    <div
      style={{
        scrollBehavior: "smooth",
        backgroundColor: "#fafafa",
        padding: "0px 0",
      }}
    >
      <VN userData={userData} />
      <Container sx={{ py: 4 }}>
        <Box sx={{ mb: 5, textAlign: { xs: "center", sm: "left" } }}>
          <h1>Regulamin weryfikacji i kontroli opiekunek</h1>
          <p className="weryfikacja__meta">
            Wersja: 1.0 &nbsp;|&nbsp; obowiązuje od: 2026-09-01
          </p>
          <Card>
            <CardContent>
              <div className="weryfikacja__toc">
                <strong>Spis treści</strong>
                <ol>
                  {sections.map((section) => (
                    <li key={section.title}>{section.title}</li>
                  ))}
                </ol>
              </div>

              {sections.map((section) => (
                <Section key={section.title} section={section} />
              ))}
            </CardContent>
          </Card>
          <footer className="weryfikacja__footer">
            <h2>Dane Operatora</h2>
            <p>
              <strong>Operator:</strong> Allworks sp. z o.o.
            </p>
            <p>
              <strong>Adres:</strong> 43-190 Mikołów, ul. Brzozowa 14D
            </p>
            <p>
              <strong>NIP:</strong> 635-184-83-80
            </p>
            <p>
              <strong>E-mail:</strong> kontakt@allworks.pl
            </p>
            <p>
              <strong>Telefon:</strong> 48 602 209 858
            </p>
          </footer>
        </Box>
      </Container>
    </div>
  );
}
